import { useSearch } from "@tanstack/react-router";

export const useQueryParams = () => {
  const searchParams = useSearch<any>({
    from: undefined,
  });

  const getAllParams = () => {
    return searchParams;
  };

  const getParam = (key: any) => {
    return searchParams?.[key];
  };

  const getAllKeys = () => {
    return Object.keys(searchParams);
  };

  const getAllEntries = () => {
    return Object.entries(searchParams);
  };

  const hasParam = (key: string) => {
    return key in searchParams;
  };

  return {
    params: getAllParams(),
    getParam,
    getAllKeys,
    getAllEntries,
    hasParam,
    searchParams,
  };
};
